import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

/**
 * Fetches a product by slug. Returns `{ product, notFound }`.
 *   • product === null while loading
 *   • notFound === true when the API responds 404
 *   • any other error triggers a redirect back to /shop
 *
 * Extracted structurally from `pages/ProductDetail.jsx`. Behavior is
 * preserved 1-for-1 — this hook only owns the fetch + navigation side-effect.
 */
export function useProductData(slug) {
  const nav = useNavigate();
  const [product, setProduct] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setProduct(null);
    setNotFound(false);
    api
      .get(`/products/${slug}`)
      .then((r) => setProduct(r.data))
      .catch((err) => {
        if (err?.response?.status === 404) setNotFound(true);
        else nav("/shop");
      });
  }, [slug, nav]);

  return { product, notFound };
}
